<template>
    <el-container style="min-height:100%;">
        <el-header></el-header>
        <el-main>
            <el-form :model="ruleForm2" :rules="rules2" ref="ruleForm2" label-position="left" label-width="0px" class="demo-ruleForm login-container">
                <h2 class="title">ORM</h2>
                <el-form-item prop="account" label="Username">
                    <el-input type="text" v-model="ruleForm2.account" auto-complete="off" placeholder="Username" @keypress.enter.native="loginFirebase"></el-input>
                </el-form-item>
                <el-form-item prop="checkPass" label="Password">
                    <el-input type="password" v-model="ruleForm2.checkPass" auto-complete="off" placeholder="Password" @keypress.enter.native="loginFirebase"></el-input>
                </el-form-item>
                <el-form-item style="width:100%;" v-if="showErrorLogin">
                    <el-alert
                        :title="showErrorMsg"
                        type="error"
                        :closable="false"
                        show-icon>
                    </el-alert>
                </el-form-item>
                <el-form-item style="width:100%;" >
                    <el-button type="primary" style="width:100%;" @click.native.prevent="loginFirebase"
                     :loading="logining">เข้าสู่ระบบ</el-button>
                </el-form-item>
            </el-form>
        </el-main>
        <el-footer></el-footer>
    </el-container>
</template>

<script>
import firebase from 'firebase/app'
import { vueAppSelMode } from '@/config'

export default {
    name: 'login',
    data () {
        return {
            logining: false,
            ruleForm2: {
                account: '',
                checkPass: '',
                selMode: vueAppSelMode || 'dev'
            },
            rules2: {
                account: [
                    { required: true, message: 'กรุณากรอกผู้ใช้งาน', trigger: 'blur' }
                    // { validator: validaePass }
                ],
                checkPass: [
                    { required: true, message: 'กรุณากรอกรหัสผ่าน', trigger: 'blur' }
                    // { validator: validaePass2 }
                ]
            },
            checked: true,
            options: [{
                value: 'dev',
                label: 'dev'
            }, {
                value: 'uat',
                label: 'uat'
            }, {
                value: 'production',
                label: 'production'
            }],
            showErrorLogin: false,
            showErrorMsg: '',
            test: ''
        }
    },
    methods: {
        handleReset2 () {
            this.$refs.ruleForm2.resetFields()
        },
        loginFirebase (ev) {
            this.$refs.ruleForm2.validate(async (valid) => {
                if (valid) {
                    this.showErrorLogin = false
                    this.logining = true
                    firebase.auth().signInWithEmailAndPassword(this.ruleForm2.account, this.ruleForm2.checkPass).then((user) => {
                        // console.log('user: ', user.user.email)
                        this.$store.set('user/objUser', user)
                        this.$store.set('envSystem/mode', this.ruleForm2.selMode)
                        this.$router.go({ path: '/oms/home' })
                        localStorage.setItem('selMode', this.ruleForm2.selMode)
                    }).catch((err) => {
                        this.ruleForm2 = {
                            account: this.ruleForm2.account,
                            checkPass: this.ruleForm2.checkPass,
                            selMode: this.ruleForm2.selMode
                        }
                        this.$refs.ruleForm2.resetFields()
                        this.showErrorLogin = true
                        this.logining = false
                        this.showErrorMsg = err.message
                        console.log(err)
                    })
                } else {
                    console.log('error submit!!')
                    return false
                }
            })
        }
    }
}
</script>

<style lang="scss" scoped>
.login-container {
    /*box-shadow: 0 0px 8px 0 rgba(0, 0, 0, 0.06), 0 1px 0px 0 rgba(0, 0, 0, 0.02);*/
    -webkit-border-radius: 5px;
    border-radius: 5px;
    -moz-border-radius: 5px;
    background-clip: padding-box;
    margin: 50px auto;
    width: 350px;
    padding: 35px 35px 15px 35px;
    background: #fff;
    border: 1px solid #eaeaea;
    box-shadow: 0 0 25px #cac6c6;
    .title {
        margin: 0px auto 40px auto;
        text-align: center;
        color: #505458;
    }
    .remember {
        margin: 0px 0px 35px 0px;
    }
}
</style>
